// extracted by mini-css-extract-plugin
export var centerText = "_d2-8";
export var container = "_d2-0";
export var doughnutContainer = "_d2-7";
export var legend = "_d2-a";
export var legendItemColorDisplay = "_d2-b";
export var legendItemLabel = "_d2-d";
export var legendItemValue = "_d2-c";
export var lg = "_d2-5";
export var maxWidth = "_d2-9";
export var md = "_d2-4";
export var responsive = "_d2-6";
export var sm = "_d2-3";
export var xs = "_d2-2";
export var xxs = "_d2-1";